import { render, staticRenderFns } from "./SurgeonPreferences.vue?vue&type=template&id=037f2cf6&"
import script from "./SurgeonPreferences.vue?vue&type=script&lang=js&"
export * from "./SurgeonPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports